export default {
	token: '', // 微信授权之后返回的凭证
	client: 1, // 客户端类型 微信:0; H5:1; App:2
  	imgBaseUrl: 'http://qn.fayuanhui.cn/default.png',
}



// WEBPACK FOOTER //
// ./src/store/state.js